import {Avatar, Drawer, SvgIcon, Tooltip} from "@mui/material";
import React, {useEffect, useState} from "react";
import styles from "./SideMenuBar.module.scss";
import  UsersIcon from "./menu_mui_icons/UsersIcon";
import  UsersIconSelected from "./menu_mui_icons/UsersIcon";
import  MapIcon from "./menu_mui_icons/MapIcon";
import  HeatMapIcon from "./menu_mui_icons/HeatMapIcon";
import  MapIconSelected from "./menu_mui_icons/MapIcon";
import  HeatMapIconSelected from "./menu_mui_icons/MapIcon";
import  UsageIcon from "./menu_mui_icons/UsageIcon";
import  UsageIconSelected from "./menu_mui_icons/UsageIcon";
import  TrainIcon from "./menu_mui_icons/TrainIcon";
import  TrainIconSelected from "./menu_mui_icons/TrainIcon";
import  DevicesIcon from "./menu_mui_icons/DevicesIcon";
import  DevicesIconSelected from "./menu_mui_icons/DevicesIcon";
import  LogoutIcon from "./menu_mui_icons/LogOutIcon";
import  LogoutIconSelected from "./menu_mui_icons/LogOutIcon";
import  AvatarIcon from "./menu_mui_icons/AvatarIcon";
import  AvatarIconSelected from "./menu_mui_icons/AvatarIcon";

import SidebarButton from "../sidebarButton/SidebarButton";
import {observer} from "mobx-react-lite";
import userService from "../../client-api/services/user";
import {UserRole} from "../../common/userRole";
import packageJson from "../../../package.json";
import AvatarMenu from "../avatarMenu/avatarMenu";
import getToken from "../../hooks/getToken";

import HealthIcon from "./menu_mui_icons/HealthIcon"
import InvalidateSessionService from "../../client-api/services/invalidateSession";
import { useMsal } from "@azure/msal-react";

import BoltIcon from '@mui/icons-material/Bolt';

import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import uiStore from "../../store/UiStore";

export interface IconButtonInterface {
    icon: any;
    selectedIcon: any;
    text: string;
    url: string;
    menuLocation: any;
    clickFunction?: any;
}

const SideMenuBar = () => {
    const userRole = userService.GetUserRole();
    const role = userRole.data ? userRole.data.role : UserRole.user;

    const [name, setName] = useState("");
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    useEffect(() => {
        getToken().then((token) => {
            if (token) {
                setName(
                    // @ts-ignore
                    token.idTokenClaims.given_name
                );
            }
        });
    }, []);


    const {refetch} = InvalidateSessionService.InvalidateSession();

    const {instance} = useMsal();

    const icons: IconButtonInterface[] = [
        {
            icon: DevicesIcon,
            selectedIcon: DevicesIconSelected,
            text: "Devices",
            url: "devices",
            menuLocation: 0,

        },
        {
            icon: TrainIcon,
            selectedIcon: TrainIconSelected,
            text: "Safety Events",
            url: "performanceReport",
            menuLocation: 0,
        },
        {
            icon: MapIcon,
            selectedIcon: MapIconSelected,
            text: "Train Route",
            url: "trainRoute",
            menuLocation: 0,
        },
        ...(uiStore.getUsersInfo().org_id === 1
        ?
        [ {
            icon: HeatMapIcon,
            selectedIcon: HeatMapIconSelected,
            text: "Heat Map",
            url: "heatMap",
            menuLocation: 0,
        },
            ]
        :[]),
        ...(role === UserRole.super_user
            ? [
                {
                    icon: UsersIcon,
                    selectedIcon: UsersIconSelected,
                    text: "Management",
                    url: "management",
                    menuLocation: 1,
                },
            ]
            : []),

        {
            icon: UsageIcon,
            selectedIcon: UsageIconSelected,
            text: "System Usage",
            url: "systemUsage",
            menuLocation: 1,
        },
        {
            icon: LogoutIcon,
            selectedIcon: LogoutIconSelected,
            text: "Logout",
            url: "logout",
            menuLocation: 1,
            clickFunction: async () => {
                await refetch();
                instance.logoutRedirect();
            },
        }
    ];


    return (
        <div className={` ${styles.sideMenuBarWrapper}`}>
            <div className={styles.sideMenuBarTop}>


                <div className={styles.sideMenuBarLogo}>
                    <svg viewBox="0 0 29.6113 18.0225" xmlns="http://www.w3.org/2000/svg"
                         width="29.611328" height="18.022461" fill="none"
                    >
                        <rect id="railvision symbol" width="29.611328" height="18.022461" x="0.000000" y="0.000000"
                              fill="rgb(255,255,255)" fill-opacity="0"/>
                        <path id="railvision symbol"
                              d="M8.94238 0C12.5746 0.00494958 15.5174 3.0793 15.5234 6.87109C15.5234 9.51393 14.0771 11.9236 11.8008 13.0752L15.2627 18.0225L8.87402 18.0225L5.09961 12.6602C4.80146 12.2114 4.64049 11.6802 4.63574 11.1357C4.624 9.63834 5.77729 8.41265 7.21191 8.40039L8.94336 8.40039C9.01722 8.40651 9.09118 8.4065 9.16504 8.40039C9.95035 8.3354 10.5384 7.61843 10.4775 6.79688C10.4153 5.97645 9.72894 5.36204 8.94238 5.42578L0 5.42578L0 0L8.94238 0ZM29.6113 18.0059L15.5254 9.00781L29.6113 0L29.6113 18.0059Z"
                              fill="rgb(237.822,11.8911,79.6703)" fill-rule="nonzero"/>
                    </svg>

                </div>

                 {icons.map((icon) => {
                            if (icon.menuLocation == 0)
                                return <SidebarButton icon={icon}/>;
                 })}

            </div>
            <div className={styles.sideMenuBarBottom}>
                 {icons.map((icon) => {
                            if (icon.menuLocation == 1)
                                return <SidebarButton icon={icon}/>;
                        })}

                  <span className={styles.version}>v {packageJson.version}</span>
            </div>

        </div>
    );
};

export default observer(SideMenuBar);




